/**
 * iRoll Rental Pricing Calculator
 */
(function () {
  'use strict';

  function calculateRentalPrice(days, model) {
    if (days <= 0) return 0;

    if (model === 'air-pro') {
      if (days === 7) return 1000;
      if (days === 30) return 1800;
      if (days < 7) {
        const daily = 350 - (350 - 1000 / 7) * ((days - 1) / 6);
        const total = Math.round(daily * days);
        // Cap so it never exceeds the 7-day flat rate
        return Math.min(total, 1000);
      }
      if (days < 30) {
        const daily = (1000 / 7) - ((1000 / 7) - (1800 / 30)) * ((days - 7) / 23);
        const total = Math.round(daily * days);
        // Cap so it never exceeds the 30-day flat rate
        return Math.min(total, 1800);
      }
      const extraDays = days - 30;
      return Math.round(1800 + extraDays * 48);
    }

    if (model === 'climber-2') {
      if (days === 7) return 1250;
      if (days === 30) return 2500;
      if (days < 7) {
        const daily = 350 - (350 - 1250 / 7) * ((days - 1) / 6);
        const total = Math.round(daily * days);
        return Math.min(total, 1250);
      }
      if (days < 30) {
        const daily = (1250 / 7) - ((1250 / 7) - (2500 / 30)) * ((days - 7) / 23);
        const total = Math.round(daily * days);
        return Math.min(total, 2500);
      }
      const extraDays = days - 30;
      return Math.round(2500 + extraDays * 66);
    }

    return 0;
  }

  function formatMoney(amount) {
    return 'R ' + amount.toLocaleString('en-ZA');
  }

  function initCalculator(container) {
    const modelCards = container.querySelectorAll('.ir-rentals__model-card');
    const daysInput = container.querySelector('.ir-rentals__days-input');
    const daysMinus = container.querySelector('.ir-rentals__days-btn--minus');
    const daysPlus = container.querySelector('.ir-rentals__days-btn--plus');
    const priceDisplay = container.querySelector('.ir-rentals__price-value');
    const pricePeriod = container.querySelector('.ir-rentals__price-period');
    const whatsappBtn = container.querySelector('.ir-rentals__calc-cta');

    let currentModel = 'air-pro';
    let currentDays = 1;

    function update() {
      const price = calculateRentalPrice(currentDays, currentModel);
      priceDisplay.textContent = formatMoney(price);
      pricePeriod.textContent = 'for ' + currentDays + ' day' + (currentDays === 1 ? '' : 's');

      // Update WhatsApp link
      const modelName = currentModel === 'air-pro' ? 'Inmotion Air Pro' : 'Inmotion Climber 2';
      const message = encodeURIComponent(
        'Hi iRoll! I\'d like to rent the ' + modelName + ' for ' + currentDays + ' day' + (currentDays === 1 ? '' : 's') + '. Please can you confirm availability and pricing?'
      );
      whatsappBtn.href = 'https://wa.me/27793463742?text=' + message;

      // Update "Book Online" link with selected params
      const bookBtn = container.querySelector('.ir-rentals__calc-cta--primary');
      if (bookBtn) {
        const productHandle = currentModel === 'air-pro' ? 'air-pro-rental' : 'climber-2-rental';
        bookBtn.href = '/pages/order?tab=rentals&product=' + productHandle + '&days=' + currentDays;
      }

      // Update model card selection state
      modelCards.forEach(function (card) {
        if (card.dataset.model === currentModel) {
          card.classList.add('ir-rentals__model-card--active');
        } else {
          card.classList.remove('ir-rentals__model-card--active');
        }
      });
    }

    modelCards.forEach(function (card) {
      card.addEventListener('click', function () {
        currentModel = card.dataset.model;
        update();
      });
    });

    if (daysMinus) {
      daysMinus.addEventListener('click', function () {
        if (currentDays > 1) {
          currentDays--;
          daysInput.value = currentDays;
          update();
        }
      });
    }

    if (daysPlus) {
      daysPlus.addEventListener('click', function () {
        if (currentDays < 90) {
          currentDays++;
          daysInput.value = currentDays;
          update();
        }
      });
    }

    if (daysInput) {
      daysInput.addEventListener('change', function () {
        let val = parseInt(daysInput.value, 10);
        if (isNaN(val) || val < 1) val = 1;
        if (val > 90) val = 90;
        currentDays = val;
        daysInput.value = val;
        update();
      });

      daysInput.addEventListener('input', function () {
        let val = parseInt(daysInput.value, 10);
        if (!isNaN(val) && val >= 1 && val <= 90) {
          currentDays = val;
          update();
        }
      });
    }

    update();
  }

  function init() {
    const calculators = document.querySelectorAll('.ir-rentals__calculator');
    calculators.forEach(initCalculator);

    // Fix broken model images
    document.querySelectorAll('.ir-rentals__model-image').forEach(function(img) {
      img.onerror = function() {
        if (img.alt === 'Inmotion Air Pro') {
          img.src = 'https://cdn.shopify.com/s/files/1/0323/9857/3707/files/207-_4.webp?v=1763988705';
        } else if (img.alt === 'Inmotion Climber 2') {
          img.src = 'https://cdn.shopify.com/s/files/1/0323/9857/3707/files/208-01_2_71d67b1d-f6d4-4b33-ad9d-bc795c3ad88d.webp?v=1763988120';
        }
      };
    });

    // Hide scooter thumbnails on rental collection page (events shown if configured)
    if (window.location.pathname === '/collections/rentals') {
      document.querySelectorAll('.ir-rentals__scooters').forEach(function(el) {
        el.style.display = 'none';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
